
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Mumps(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Mumps(parotitis)"}></DetailHeader>

                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Mumps is a <b>a viral infection that primarily affects salivaproducing (salivary) glands</b> that are located near your
                                    ears. Mumps can cause swelling in one or both of these
                                    glands.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Mumps(parotitis)/1.png")} alt="Mumps(parotitis)" />
                                    </div>
                                </div>
                                <br></br>
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <ul className="listUnstyle">
                                    <li>
                                        <p>
                                            <b>Pain areas:</b>
                                            <br />
                                            in the abdomen, muscles, neck, pelvis, or testicle
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Whole body:</b>
                                            <br />
                                            chills, fatigue, fever, loss of appetite, or malaise
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Throat:</b>
                                            <br />
                                            difficulty swallowing or soreness
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <b>Also common: </b>
                                            <br />
                                            dry mouth, headache, hearing loss, neck swelling, swollen lymph
                                            nodes, or swollen salivary glands
                                        </p>
                                    </li>
                                </ul>
                                <a className="links" href="https://en.wikipedia.org/wiki/Mumps">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Mumps;